import { ProductHeading } from "./ProductBrand";
import { BONDOQ_VARS } from "./productTheme";
import { useProductIdentity } from "./useProductIdentity";

export function ProductLoading() {
  useProductIdentity("bondoq", "Your workspace");
  return (
    <div
      style={{
        ...BONDOQ_VARS,
        minHeight: "100dvh",
        background: "var(--bg)",
        color: "var(--text)",
        fontFamily: "var(--pm-font)",
      }}
    >
      <header
        className="product-topbar"
        data-product="bondoq"
        style={{ padding: "22px", minHeight: 76 }}
      >
        <ProductHeading label="Workspace" />
      </header>
      <p role="status" style={{ textAlign: "center", padding: "64px 24px" }}>
        Opening your workspace…
      </p>
    </div>
  );
}
